import { FhirInstance } from '../config/FhirClient';
import { IBundle } from '../modules/unsw-fhir/Bundle';
import {
  IOperationOutcome,
  isOperationOutcome,
} from '../modules/unsw-fhir/OperationOutcome';
import { IQuestionnaire } from '../modules/unsw-fhir/Questionnaire';
import { isQuestionnaire } from '../modules/unsw-fhir/Questionnaire/typeGuards';
import { IReference } from '../modules/unsw-fhir/Reference';

export const getQuestionnaireByName = async (name: string) => {
  try {
    const response = await FhirInstance.get<IBundle | IOperationOutcome>(
      '/Questionnaire',
      { params: { name } },
    );
    const { data } = response;
    if (isOperationOutcome(data) || !data.entry) {
      return undefined;
    }
    return data.entry
      .filter(entry => {
        return !!entry.resource && isQuestionnaire(entry.resource);
      })
      .map((entry): IQuestionnaire => entry.resource as IQuestionnaire)[0];
  } catch (e) {
    console.error(e);
    return undefined;
  }
};

export const getQuestionnaires = async (summary?: boolean) => {
  try {
    const params: { [key: string]: any } = {};
    if (summary) params.summary = true;

    const response = await FhirInstance.get<IBundle | IOperationOutcome>(
      '/Questionnaire',
      { params },
    );
    const { data } = response;
    if (isOperationOutcome(data) || !data.entry) {
      return [];
    }
    return data.entry
      .filter(entry => {
        return !!entry.resource && isQuestionnaire(entry.resource);
      })
      .map((entry): IQuestionnaire => entry.resource as IQuestionnaire);
  } catch (e) {
    console.error(e);
    return [];
  }
};

export const getQuestionnaireById = async (id?: string) => {
  if (!id) return undefined;
  try {
    const response = await FhirInstance.get<IQuestionnaire | IOperationOutcome>(
      `/Questionnaire/${id}`,
    );
    const { data } = response;
    if (isOperationOutcome(data) || !data) {
      return undefined;
    }
    return data;
  } catch (e) {
    console.error(e);
    return undefined;
  }
};

export const getQuestionnaireByReference = async (ref?: IReference) => {
  if (!ref || !ref.reference) return undefined;
  try {
    const response = await FhirInstance.get<IQuestionnaire | IOperationOutcome>(
      ref.reference,
    );
    const { data } = response;
    if (isOperationOutcome(data) || !data) {
      return undefined;
    }
    return data;
  } catch (e) {
    console.error(e);
    return undefined;
  }
};

export const getQuestionnaireByNameHook = async (name: string) => {
  const response = await FhirInstance.get<IBundle | IOperationOutcome>(
    '/Questionnaire',
    { params: { name } },
  );
  const { data } = response;
  if (isOperationOutcome(data)) {
    throw new Error(data.text || 'Request failed');
  }

  if (!data.entry) {
    return undefined;
  }

  return data.entry
    .filter(entry => {
      return !!entry.resource && isQuestionnaire(entry.resource);
    })
    .map((entry): IQuestionnaire => entry.resource as IQuestionnaire)[0];
};
